import { Chip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { common, financedEmissions } from "../../i18n";
import { ListingStatus } from "../../models/dto/cat15/cat15.types";

// financedEmissions keys; the list row and the chip must name a listing the same way.
export const listingStatusLabelKey = (status: ListingStatus | null) =>
  status === null ? "Not-Provided" : status === "listed" ? "Listed" : "Unlisted";

interface Props {
  // null = left for the borrower to answer
  status: ListingStatus | null;
  size?: "small" | "medium";
}

const ListingStatusChip = ({ status, size = "small" }: Props) => {
  const { t } = useTranslation([financedEmissions, common], {
    nsMode: "fallback",
  });
  if (status === null) {
    // Dashed and white, so an unanswered listing never reads as the grey "Unlisted".
    return (
      <Chip
        size={size}
        variant="outlined"
        label={t(listingStatusLabelKey(status))}
        sx={{
          borderRadius: "16px",
          fontWeight: 600,
          color: "var(--gray9)",
          backgroundColor: "var(--white)",
          border: "1px dashed var(--gray4)",
        }}
      />
    );
  }
  const listed = status === "listed";
  return (
    <Chip
      size={size}
      label={t(listingStatusLabelKey(status))}
      sx={{
        // Figma borrower header (node 6384:16822): "Listed" = purple pill
        // (#ecd7fc / #8a0ded), 16px radius.
        borderRadius: "16px",
        fontWeight: 600,
        color: listed
          ? "var(--status-owned-and-leased-out-text)"
          : "var(--status-draft-inactive-text)",
        backgroundColor: listed
          ? "var(--status-owned-and-leased-out-bg)"
          : "var(--status-draft-inactive-bg)",
      }}
    />
  );
};

export default ListingStatusChip;
